export default "__VITE_ASSET__BGmGGB4R__"